<div class="banner-manager">
  <h1>Bandeau</h1>

  @if (saveError(); as error) {
    <div class="warning-box" role="alert">{{ error }}</div>
  }

  <section class="banner-bookmarks" aria-labelledby="banner-bookmarks-title">
    <h2 id="banner-bookmarks-title">Modèles prédéfinis</h2>

    <div class="banner-bookmark-list">
      @for (bookmark of bookmarks; track bookmark.title) {
        <button
          mat-stroked-button
          type="button"
          class="banner-bookmark"
          (click)="applyBookmark(bookmark)"
        >
          {{ bookmark.title }}
        </button>
      }
    </div>
  </section>

  <form class="banner-form" [formGroup]="form" (ngSubmit)="saveBanner()">
    <div class="banner-sections">
      @for (section of sections; track section.id) {
        <mat-card class="banner-section">
          <mat-card-header>
            <mat-card-title>{{ section.title }}</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <div class="banner-fields">
              @for (field of section.fields; track field.controlName) {
                <mat-form-field
                  appearance="outline"
                  class="banner-field"
                  [class.banner-field-invalid]="form.controls[field.controlName].invalid"
                >
                  <mat-label>{{ field.label }}</mat-label>
                  <textarea
                    matInput
                    [formControlName]="field.controlName"
                    rows="5"
                  ></textarea>
                  @if (form.controls[field.controlName].hasError('invalidHtml')) {
                    <mat-error>Le contenu HTML est invalide.</mat-error>
                  }
                </mat-form-field>
              }
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>

    <button mat-flat-button color="primary" type="submit">
      Sauvegarder et montrer aux utilisateurs
    </button>
  </form>
</div>
